import { render, staticRenderFns } from "./performance_config_list.vue?vue&type=template&id=3f403f88&scoped=true"
import script from "./performance_config_list.vue?vue&type=script&lang=js"
export * from "./performance_config_list.vue?vue&type=script&lang=js"
import style1 from "../../../assets/styles/management.scss?vue&type=style&index=1&id=3f403f88&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f403f88",
  null
  
)

export default component.exports